import classNames from "classnames";
import React, { useContext } from "react";
import { parseLink } from "./../../ricos-content/lib/nodeUtils";
import { ToolbarContext } from "./../../ricos-context";
import { EditorBaseUrlContext } from "./../../_shared/editor-base-url/editor-base-url-context";
import { getEditableUrl } from "./../../_shared/url/get-editable-url";
import { getHrefUrl } from "./../../_shared/url/get-href-url";
import styles from "./url-link-button-scss";
const UrlLinkButton = ({ toolbarItem }) => {
  const { baseUrl } = useContext(EditorBaseUrlContext);
  const { isMobile } = useContext(ToolbarContext);
  const selectedUrlLinkData = toolbarItem.attributes.selectedUrlLinkData;
  const dataHook = toolbarItem.presentation?.dataHook;
  const { url = "", rel = "", target = "_self" } = parseLink(selectedUrlLinkData);
  const editableUrl = getEditableUrl(url, baseUrl);
  const hrefUrl = getHrefUrl(url, baseUrl);
  return /* @__PURE__ */ React.createElement("div", { className: styles.toolbarUrlContainer }, /* @__PURE__ */ React.createElement(
    "a",
    {
      "data-hook": dataHook,
      href: hrefUrl,
      rel,
      target,
      className: classNames(styles.toolbarUrl, isMobile && styles.isMobile),
      onMouseDown: (event) => event.preventDefault()
    },
    editableUrl
  ));
};
export {
  UrlLinkButton
};
//# sourceMappingURL=url-link-button.js.map
